interface IconProps {
  color?: string;
  size?: string | number;
}

const RarityCommonIcon = ({ color = "currentColor", size = 24 }: IconProps) => {
  return (
    <svg height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21.5C9.35357 21.5 7.10863 20.5783 5.26518 18.7348C3.42173 16.8914 2.5 14.6464 2.5 12C2.5 9.35357 3.42173 7.10863 5.26518 5.26518C7.10863 3.42173 9.35357 2.5 12 2.5C14.6464 2.5 16.8914 3.42173 18.7348 5.26518C20.5783 7.10863 21.5 9.35357 21.5 12C21.5 14.6464 20.5783 16.8914 18.7348 18.7348C16.8914 20.5783 14.6464 21.5 12 21.5Z" />
    </svg>
  );
};

export default RarityCommonIcon;
